import { PrivacyOptInConfirm } from 'components/account/privacy/opt-in-confirm';
import { withModal } from 'components/common/modal/withModal';
import { compose } from 'redux';

const enhance = compose(withModal);
const PrivacyOptInConfirmContainer = enhance(PrivacyOptInConfirm);

export { PrivacyOptInConfirmContainer };
